<!--
@author: huangzhijie
@date: 23.8.15
@description: icon
-->
<template>
  <svg :width="width" :height="height" :fill="fill" aria-hidden="true" focusable="false" class="" @click="handleClick($event)">
    <use :xlink:href="href"></use>
  </svg>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  fill: {
    type: String,
    default: 'currentColor',
  },
  width: {
    type: String,
    default: '1em',
  },
  height: {
    type: String,
    default: '1em',
  },
  href: {
    type: String,
    default: '#icon-api-search',
  },
  clickStop: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['click']);
const handleClick = (event) => {
  emit('click');
  if (props.clickStop) {
    event.stopPropagation();
  }
};


</script>
<script>
export default {
  name: 'ApiIcon',
};
</script>

<style lang="less" scoped>
.api-btn-wrapper {
  .api-btn {
    cursor: pointer;
    transition: all .2s linear;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;

    // svg {
    //   color:
    // }

    &:hover {
      background-color: rgba(16, 24, 40, 0.04);
    }
  }
}
</style>
